import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { BaseModalComponent } from 'src/app/core/base-modal.componant';
import { Simulator } from 'src/app/simulator-booking/models/simulators';
import { SimulatorService } from 'src/app/simulator-booking/services/simulator.service';
import { SessionService } from 'src/app/shared/services/session.service';

@Component({
    selector: 'simulator-edit-modal',
    templateUrl: './simulator-edit-modal.component.html',
    styleUrl: './simulator-edit-modal.component.scss',
    standalone: false
})
export class SimulatorEditModalComponent extends BaseModalComponent implements OnInit {
  simulator: Simulator;
  isLoading: boolean = false;

  form = new FormGroup({
    id: new FormControl(null, [Validators.required]),
    bayName: new FormControl(null, [Validators.required]),
    bayNumber: new FormControl(null, [Validators.required]),
    capacity: new FormControl(null, [Validators.required]),
    isAvailable: new FormControl(true)
  });

  constructor(
    private simulatorService: SimulatorService,
    public dialogRef: MatDialogRef<SimulatorEditModalComponent>,
    private sessionService: SessionService
  ) {
    super();
  }

  ngOnInit() {
    if (this.simulator) {
      this.form.patchValue({
        id: this.simulator.id,
        bayName: this.simulator.bayName,
        bayNumber: this.simulator.bayNumber,
        capacity: this.simulator.capacity,
        isAvailable: this.simulator.isAvailable
      });
    }
  }

  submit() {
    if (this.form.valid) {
      this.isLoading = true;
      const data = {
        ...this.form.value,
        organizationId: this.simulator.organizationId,
        lastEditedBy: this.sessionService.getUser().id
      };

      this.simulatorService.update(this.simulator.id, data).subscribe({
        next: () => {
          this.dialogRef.close('save');
        },
        error: (error) => {
          console.error(error);
          this.isLoading = false;
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    }
  }
}
